import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthEmpleadoContext } from "../../../context/AuthEmpleadoContext";
import AppContext from "../../../AppContext";
import "./LoginEmpleado.css";
import imgLogIn from "../../../assets/images/logocolegio.png";
import RecuperarPasswordModal from "./RecuperarPasswordModal";

function LoginEmpleado() {
  const { loginEmpleado } = useContext(AuthEmpleadoContext);
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState("");
  const [clave, setClave] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showRecuperarModal, setShowRecuperarModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);

    try {
      const loginUrl = `${AppContext.baseApiUrl}${AppContext.urlServiceLoginEmpleados}`;
      const res = await axios.post(loginUrl, {
        mail: usuario,
        clave,
      });

      loginEmpleado(res.data);
      navigate("/DashboardEmpleados");
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-empleado-container">
      <div className="login-empleado-left">
        <img src={imgLogIn} alt="Colegio Santo Tomás" />
        <button
          type="button"
          className="link login-empleado-link-button"
          onClick={() => setShowRecuperarModal(true)}
        >
          ¿Has olvidado la contraseña?
        </button>
      </div>

      <div className="login-empleado-card">
        <h2>ACCESO EMPLEADOS</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email institucional"
            aria-label="Email institucional"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Contraseña"
            aria-label="Contraseña"
            value={clave}
            onChange={(e) => setClave(e.target.value)}
            required
          />

          <button type="submit" disabled={loading}>
            {loading ? "Ingresando..." : "INGRESAR"}
          </button>

          {error && <p className="error">Usuario o contraseña incorrectos</p>}
        </form>
      </div>

      <RecuperarPasswordModal
        show={showRecuperarModal}
        onHide={() => setShowRecuperarModal(false)}
        tipoAcceso="Acceso Empleados"
        email={usuario}
      />
    </div>
  );
}

export default LoginEmpleado;
